import { Button } from '@octopus-do/octopus-storybook'
import { useEffect } from 'react'

const UnsavedChanges = (props) => {
  const { cancelButton, confirmCb } = props

  useEffect(() => {
    function onDocumentKeydown(e) {
      if (e.which === 8 || e.which === 13) {
        confirmCb()
      }
    }

    document.addEventListener('keydown', onDocumentKeydown)

    return function close() {
      document.removeEventListener('keydown', onDocumentKeydown)
    }
  })

  return (
    <div className="System-dialog__inner">
      <div className="System-dialog__title">Unsaved changes</div>

      <div className="System-dialog__description">
        <p>
          Are you sure you want to discard this edit?
          <br />
          Your changes will be lost.
        </p>
      </div>

      <div className="System-dialog__buttons">
        <div className="System-dialog__buttons-item">
          <Button
            tone="danger"
            size="medium"
            label="Discard"
            onClick={confirmCb}
          />
        </div>

        <div className="System-dialog__buttons-item">{cancelButton}</div>
      </div>
    </div>
  )
}

export default UnsavedChanges
